module.exports = __webpack_public_path__ + "img/3.f8deda3e.png";